'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Icon = require('../Icon-deabd942.js');
var React = _interopDefault(require('react'));
require('@carbon/icon-helpers');
require('prop-types');

var Archive16 =
/*#__PURE__*/
React.forwardRef(function Archive16(props, ref) {
  return React.createElement(Icon.Icon, Icon._extends({
    width: 16,
    height: 16,
    viewBox: "0 0 32 32",
    ref: ref
  }, props), React.createElement("rect", {
    width: "4",
    height: "2",
    x: "14",
    y: "19"
  }), React.createElement("path", {
    d: "M6,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V2ZM24,28H8V16H24Zm0-14H8V10H24ZM8,8V4H24V8Z"
  }), props.children);
});

module.exports = Archive16;
